import logo from "../../assets/ecomlovers-logo-transparente.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "./UserTypeSelector.css"
import iconHeart from "../../assets/Vector (23).png";
import LoginWeb from "./LoginWeb";
import icon1 from "../../assets/Captura de Tela 2024-06-18 às 19.42.20 1.png";
import { initializeUtmTracking, getUtmQueryString } from "../../utils/utmHelper";

export const UserTypeSelector = () => {
  const navigate = useNavigate();

  // Capture and save UTMs when component mounts
  useEffect(() => {
    initializeUtmTracking();
  }, []);

  const handleTalentClick = () => {
    const utmQuery = getUtmQueryString();
    navigate(`/talents${utmQuery}`);
  };

  const handleCompanyClick = () => {
    const utmQuery = getUtmQueryString();
    navigate(`/companies${utmQuery}`);
  };

  return (
    <>
      <LoginWeb />
      <div className="containerLogin">
        <div className="containerContentALl">
          <div
            style={{
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "15px",
              gap: "5px",
            }}
            className="backGrounDivid"
          >
            <img
              src={logo}
              alt="logo"
              className="logo"
            />

            <div className="lineLOgin" />
          </div>
          <div className="contentContainerUserTypeSelector">
            <div className="contentContainer">
              <img
                src={icon1}
                alt="icon"
                className="iconlogin1"
              />
              <div className="title">Bem-vindo à eComLovers!</div>

              <div
                className="containerButtonsUserTypeSelector"
                style={{ marginTop: "10px", marginBottom: "50px" }}
              >
                <div
                  className="buttonLogin buttonLoginTalent"
                  onClick={handleTalentClick}
                >
                  Sou um talento
                </div>
                <div
                  className="buttonLogin buttonLoginCompany"
                  onClick={handleCompanyClick}
                  style={{ marginTop: "10px", cursor: "pointer" }}
                >
                  Sou uma empresa
                </div>
              </div>
            </div>
          </div>
          <div className="footerLOgin">
            Desenvolvido com
            <img src={iconHeart} alt="" />
            <strong>© eComLovers®</strong>
          </div>
        </div>
      </div>
    </>
  );
};
